import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import { NotificationManager } from "react-notifications";

// Services
import postosService from "@services/postos";
import tpvService from "@services/tpv";
import operadoresService from "@services/operadores";
import paymentsService from "@services/payments";

// Components
import Menu from "@components/Menu";

/* Import Components */
import AutoCompleteField from "@components/AutoCompleteV2";
import TextField from "@components/TextField";
import {
    MdTurnLeft,
    MdAddCircleOutline
} from "react-icons/md";
import ClipLoader from "react-spinners/ClipLoader";


import UserContext from "@components/context/userContext";

class Form extends Component {
  static contextType = UserContext;

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    const {
      match: { params },
    } = this.props;

    this.state = {
      loaded: false,
      posto: "",
      tpv: "",
      turno: "",
      operador: "",
      valor: "",
      cod_raspadinha: "",
      nome_raspadinha: "",
      postos: [],
      tpvs: [],
      enableTpv: false,
      type: params.type,
      idempresa: this.props.cookies.get("member_idempresa"),
      isSubmitting: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFormCancel = this.handleFormCancel.bind(this);
    this.loadFunction = this.loadFunction.bind(this);
  }

  async loadFunction() {
    const profile = this.context;

    if (!this.state.loaded) {
      try {
        const postos = await postosService.get(profile.idEmpresa);
        
        this.setState({
          postos: postos.filter((p) => p.posto > 0),
          loaded: true,
        });
      } catch (error) {
        console.error('Erro ao carregar postos:', error);
      }
    }
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({
      [name]: value,
    });
  }

  async handleFormSubmit(e) {
    const profile = this.context;

    const { history } = this.props;
    e.preventDefault();

    this.setState({
      loaded: true,
      isSubmitting: true,
    });

    try {
      await paymentsService.set({
        idempresa: profile.idEmpresa,
        posto: this.state.posto,
        tpv: this.state.tpv,
        turno: this.state.turno,
        operador: this.state.operador,
        valor: this.state.valor,
        cod_raspadinha: this.state.cod_raspadinha,
        nome_raspadinha: this.state.nome_raspadinha,
        type: 'JSCM',
      });

      NotificationManager.success("Guardado com sucesso", "Pagamento");
      history.push("/payments");
    } catch (error) {
      console.error('Erro ao submeter pagamento:', error);
      NotificationManager.error("Erro ao submeter pagamento", "Pagamento");
    } finally {
      this.setState({ isSubmitting: false });
    }
  }

  handleFormCancel() {
    const { history } = this.props;
    history.push("/payments");
  }

  render() {
    const { location, history } = this.props;
    const {
      loaded,
      postos,
      posto,
      tpvs,
      tpv,
      turno,
      operadores,
      operador,
      valor,
      cod_raspadinha,
      nome_raspadinha,
      enableTpv,
      enableForm,
      isSubmitting,
    } = this.state;
    const cookies = new URLSearchParams(location.search);

    const canSubmit =
        posto &&
        tpv &&
        operador &&
        valor &&
        cod_raspadinha &&
        !isSubmitting;

    return (
      <div>
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-xs-12">
            <ol
              style={{
                textAlign: "left",
                marginTop: "75px",
              }}
              className="breadcrumb"
            >
              <li>
                <a href="http://eposgestofinal.com/index.php">Portal</a>
              </li>
              <li>
                <a href="/payments">Pagamentos</a>
              </li>
              <li className="active">
                <span>Novo Pagamento</span>
              </li>
            </ol>
          </div>
        </div>
        {loaded && (
          <div className="fullContainer" style={{ maxWidth: "100%" }}>
            <div className="col-sm-12" style={{ textAlign: "center" }}>
              <div className="panel panel-default">
                  <div
                    style={{
                      display: "grid",
                      gap: "24px",
                    }}
                  >
                    {/* NIF Card */}
                    <div
                      style={{
                        backgroundColor: "white",
                        borderRadius: "12px",
                        overflow: "hidden",
                        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        style={{
                          padding: "16px 24px",
                          borderBottom: "1px solid #e2e8f0",
                          backgroundColor: "#f8fafc",
                        }}
                      >
                        <h2
                          style={{
                            fontSize: "1.25rem",
                            fontWeight: "600",
                            color: "#1e293b",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          Informações do Posto
                        </h2>
                      </div>
                      <div
                        style={{
                          padding: "24px",
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(250px, 1fr))",
                          gap: "20px",
                        }}
                      >
                        <AutoCompleteField
                          options={postos}
                          value={postos.find(
                            (p) => Number(p.posto) === Number(posto)
                          )}
                          onChange={async (_, thisPosto) => {
                            const profile = this.context;

                            try {
                              const tpvs = await tpvService.get(profile.idEmpresa, thisPosto.posto);

                              this.setState({
                                posto: thisPosto.posto,
                                tpvs,
                                tpv: "",
                                enableTpv: true,
                                loaded: true,
                              });
                            } catch (error) {
                              console.error('Erro ao carregar TPVs:', error);
                            }
                          }}
                          getOptionLabel={(option) => option.nome || ""}
                          label="Selecione um posto"
                        />
                        {enableTpv ? (
                          <AutoCompleteField
                            options={tpvs}
                            value={tpvs.find(
                              (t) => Number(t.tpv) === Number(tpv)
                            )}
                            onChange={async (_, thisTpv) => {
                              const profile = this.context;

                              try {
                                const operadores = await operadoresService.get(
                                  profile.idEmpresa,
                                  posto,
                                  thisTpv.tpv
                                );

                                this.setState({
                                  tpv: thisTpv.tpv,
                                  turno: thisTpv.last_turno,
                                  operador: thisTpv.last_operador,
                                  operadores,
                                  enableForm: true,
                                  loaded: true,
                                });
                              } catch (error) {
                                console.error('Erro ao carregar operadores:', error);
                              }
                            }}
                            getOptionLabel={(option) => option.tpv || ""}
                            label="Selecione um tpv"
                          />
                        ) : null}
                      </div>

                      {enableTpv && enableForm ? (
                        <div
                          style={{
                            padding: "24px",
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fit, minmax(250px, 1fr))",
                            gap: "20px",
                          }}
                        >
                          <AutoCompleteField
                            options={operadores}
                            value={operadores.find(
                              (t) => Number(t.operador) === Number(operador)
                            )}
                            onChange={(_, thisOperador) => {
                              this.setState({
                                operador: thisOperador.operador,
                              });
                            }}
                            getOptionLabel={(option) =>
                              option.nome_operador || ""
                            }
                            label="Selecione um Operador"
                          />
                          <TextField
                            type="number"
                            min="1"
                            step="1"
                            label="Turno"
                            value={turno}
                            onChange={(e) => {
                              this.setState({ turno: Number(e.target.value) });
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                    {enableTpv && enableForm ? (
                    <div
                      style={{
                        backgroundColor: "white",
                        borderRadius: "12px",
                        overflow: "hidden",
                        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        style={{
                          padding: "16px 24px",
                          borderBottom: "1px solid #e2e8f0",
                          backgroundColor: "#f8fafc",
                        }}
                      >
                        <h2
                          style={{
                            fontSize: "1.25rem",
                            fontWeight: "600",
                            color: "#1e293b",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          Santa Casa da Misericórdia
                        </h2>
                      </div>
                      <div
                        style={{
                          padding: "24px",
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(250px, 1fr))",
                          gap: "20px",
                        }}
                      >
                        <TextField
                          type="number"
                          min="0"
                          step="0.01"
                          label="Valor"
                          value={valor}
                          onChange={(e) => {
                            this.setState({ valor: Number(e.target.value) });
                          }}
                        />
                        <TextField
                          type="text"
                          label="Nome Raspadinha"
                          value={nome_raspadinha}
                          onChange={(e) => {
                            this.setState({ nome_raspadinha: e.target.value });
                          }}
                        />
                      </div>
                      <div
                        style={{
                          padding: "24px",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(450px, 2fr))",
                          gap: "20px",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          type="text"
                          label="Código"
                          value={cod_raspadinha}
                          onChange={(e) => {
                            this.setState({ cod_raspadinha: e.target.value });
                          }}
                        />
                      </div>
                    </div>
                    ) : null}
                </div>

                <div
                    style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "16px",
                    marginTop: "32px",
                    padding: "24px",
                    backgroundColor: "white",
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <button
                    type="button"
                    onClick={() => history.push('/payments')}
                    className="back-button"
                >
                    <MdTurnLeft size={28} />&nbsp;&nbsp;Voltar
                </button>
                <button type="button" disabled={!canSubmit} onClick={this.handleFormSubmit} className="submit-button">
                    { isSubmitting ? <ClipLoader size={20} /> : <MdAddCircleOutline size={28} /> }&nbsp;&nbsp;Submeter pagamento
                    </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withCookies(Form);
